module.exports = __webpack_public_path__ + "img/to_sudoku_jp.aa18b771.png";